import { rem } from "polished";
import styled from "styled-components";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { Heading } from "@/components/editor/shared/schedules/empty-item-component-styles";
import { Typography } from "@/components/editor/shared/typography";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const Wrapper = withViewportStyle(BlockPaddingWrapper)`
  background: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
  color: ${(props) => props.theme.colors[ColorLabels.SECONDARY_FONT]};

  ${(props) => props.$viewport.mobile`
    padding: ${rem(64)} ${rem(16)};
  `}
`;

export const StyledScheduleTitle = withViewportStyle("div")`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(40)};

  ${(props) => props.$viewport.mobile`
    margin-bottom: ${rem(24)};
  `}
`;

export const FilterWrapper = withViewportStyle("div")`
  .filter-menu {
    position: relative;
    margin-right: ${rem(16)};

    ${(props) => props.$viewport.mobile`
      margin: 0;
    `}
  }
`;

export const StyledSchedulesList = withViewportStyle("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: ${rem(24)};

  ${(props) => props.$viewport.tablet`
    grid-template-columns: 1fr;
  `}
`;

export const StyledScheduleCardHeader = withViewportStyle("div")`
  padding-bottom: ${rem(14)};
  margin-bottom: ${rem(24)};
  border-bottom: 1px solid ${(props) =>
    props.theme.colors[ColorLabels.PRIMARY]};

  ${(props) => props.$viewport.tablet`
    padding-bottom: ${rem(10)};
    margin-bottom: ${rem(20)};
  `}

  display: flex;

  ${Typography} {
    flex: 1;
  }

  .addeventatc {
    ${(props) => props.$viewport.mobile`
      width: min-content;
    `}
  }
`;

export const StyledScheduleCard = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(36)};
`;

export const StyledScheduleCardBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const StyledScheduleSegment = withViewportStyle("div")`
  margin-bottom: ${rem(16)};

  ${(props) => props.$viewport.tablet`
    margin-bottom: ${rem(8)};
  `}
`;

export const StyledScheduleName = withViewportStyle("div")`
  margin-bottom: ${rem(8)};
`;

export const StyledSpeakersList = styled.div`
  margin-top: ${rem(20)};
  margin-left: ${rem(8)};
`;

export const StyledCalendarButton = styled.button`
  width: ${rem(30)};
  height: ${rem(30)};
  color: ${(props) => props.theme.colors[ColorLabels.SECONDARY_FONT]};
`;

export const EmptyItemWrapper = withViewportStyle("div")`
  ${Heading} { 
    color: ${(props) => props.theme.colors[ColorLabels.SECONDARY_FONT]};
  }
`;

export const StyledMenuContent = withViewportStyle("div")<{
  $editing: boolean;
}>`
  position: absolute;
  top: 100%;
  right: 0;
  min-width: ${rem(225)};
  background-color: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
  box-shadow: 0 ${rem(5)} ${rem(20)} rgba(0, 0, 0, 0.33);
  padding: ${rem(24)};
  margin-top: ${rem(8)};
  -webkit-tap-highlight-color: transparent;
  z-index: var(--z-index-highest);

  ${(props) => props.$viewport.mobile`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: var(--z-index-highest);
    margin-top: unset;

    ${
      props.$editing &&
      `
      max-width: ${rem(364)};
      left: ${rem(48)};
      `
    }
  `}
`;
